import gql from 'graphql-tag';

export default gql`
    query GetConversationByDriverIdWithFilter($input: DriverConversationInput, $offset: Int) {
        getConversationByDriverIdWithFilter(input: $input, offset: $offset) {
            messageId
            conversationId
            creationDate
            isFromDriver
            isGrupal
            loadId
            lastMessageRead
            id
            driverid
            driver {
                id
                name
                isDeleted
                isActive
                isAssigned
                isManual
                isAvailable
                driverCompanyId
                driverCompanyName
                isPreferred
                isShiftStarted
            }
            message {
                id
                creationDate
                subjectMessage
                bodyMessage
                messageType
                attMssageId
                attRequestId
            }
            totalCount
        }
    }
`;
